module.exports = __webpack_public_path__ + "img/vendor_reports_icon.f8a03dfe.svg";